import { render, staticRenderFns } from "./projects-list.vue?vue&type=template&id=2f0c6695&scoped=true"
import script from "./projects-list.vue?vue&type=script&lang=js"
export * from "./projects-list.vue?vue&type=script&lang=js"
import style0 from "./projects-list.vue?vue&type=style&index=0&id=2f0c6695&prod&lang=scss"
import style1 from "./projects-list.vue?vue&type=style&index=1&id=2f0c6695&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0c6695",
  null
  
)

export default component.exports